import React, { useContext } from 'react';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';

import HomePage from './components/HomePage';
import TryAgain from './components/TryAgain';
import quiz from '../undraw_adventure_4hum 1.svg'
import { Context } from './ContextProvider'

function App() {
    const { isNextPageShown } = useContext(Context)
    
    return (
        <article className='quiz-container'>
            <h1>Country Quiz</h1>
            <img className="quiz-img" src={quiz} alt="quizimg"/>
            <Router>
                <Switch>
                    <Route exact path='/'>
                        <HomePage/>
                    </Route>
                    <Route path='/try_again'>
                        {!isNextPageShown && <TryAgain />}
                    </Route>
                </Switch>
            </Router>
        </article>
    )
}

export default App